import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { setOptions, overrideComponent, setMetadata } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepTeacherPersonalInfoComponent } from './components/steps/StepTeacherPersonalInfoComponent';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';
import { StepPendingComponent } from './components/steps/StepPendingComponent';
import { getQueryParamsByName } from './lib/utils/browser';

const userName = getQueryParamsByName('userName') || '';

setOptions(defaultOptions);
googleTagManagerHook();
setMetadata({ userName: userName })


// @ts-ignore
overrideComponent("StepTeacherPersonalInfoComponent", StepTeacherPersonalInfoComponent);
// @ts-ignore
overrideComponent("StepSuccessComponent", StepSuccessComponent);
// @ts-ignore
overrideComponent("StepPendingComponent", StepPendingComponent);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
